import styled from 'styled-components';

export const Input = styled.input`

`;

export const Button = styled.button`

`;